import "./App.css";
import Router from "./config/Router";

function App() {
  return <Router />;
}

export default App;
